import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import styled, { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
// import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  .AreaInfo_Inner {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
  }
  .AreaInfo_Content {
    width:100%;
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
    padding:60px;
    text-align: center;
    @media (min-width: 1199px) {
      width:50%;
      padding:100px 60px;
    }
    .AreaInfo_Title {
      font:900 24px/30px ${typography.SansSerif};
      color:${colors.color1};
      @media (min-width: 480px) {
        font:900 36px/43px ${typography.SansSerif};
      }
      &:after {
        content:'';
        width:100px;
        height:2px;
        background-color:${colors.color2};
        display:block;
        margin:30px auto 30px auto;
        @media (min-width: 480px) {
          margin:30px auto 50px auto;
        }
      }
      span {
        font:700 24px/30px ${typography.Serif};
        text-transform: uppercase;
        color:${colors.color2};
        display: block;
        margin-bottom:10px;
        @media (min-width: 480px) {
          font:700 18px/1.2 ${typography.Serif};
        }
      }
    }
    .AreaInfo_Body {
      font:300 14px/20px ${typography.SansSerif};
      @media (min-width: 480px) {
        font:300 18px/36px ${typography.SansSerif};
      }
    }
  }
  .AreaInfo_Media {
    width:100%;
    background-size:cover;
    background-position: center;
    min-height:300px;
    @media (min-width: 1199px) {
      width:50%;
    }
  }
`;

function AreaInfo({ area, className }) {
  return (
    <div className={className}>
      <div className="AreaInfo_Wrapper">
        <div className="AreaInfo_Inner">
          <div className="AreaInfo_Content">
            <h3 className="AreaInfo_Title">
              <span>New Home Communities</span>
              {get(area, 'name')}
            </h3>
            <div className="AreaInfo_Body" dangerouslySetInnerHTML={SanitizeHtml(get(area, 'description'))} />
          </div>
          <div className="AreaInfo_Media" style={{ backgroundImage: `url(${buildThumbnailUrl(get(area, 'logo.contentUrl'), { width: 2000, height: 2000, preserve: true })})` }} />
        </div>
      </div>
    </div>
  );
}

AreaInfo.propTypes = {
  area: PropTypes.object,
  className: PropTypes.string,
};

AreaInfo.defaultProps = {
  area: undefined,
  className: undefined,
};

export default styled(AreaInfo)(styles);



// WEBPACK FOOTER //
// ./src/pages/Communities/AreaInfo.js